var map = {
	"./exams/NVR1/1.jpg": 410,
	"./exams/NVR1/2.jpg": 670,
	"./exams/NVR1/3.jpg": 384,
	"./exams/VR1/1.jpg": 119,
	"./exams/exams": 722,
	"./exams/exams.json": 722
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 606;